import React from 'react'
import { TradingEntity } from 'api'
import { ProductRightsPanel } from 'view/routes/admin/common'

interface ProductsPanelProps {
  tradingEntity: TradingEntity
  readOnly: boolean
  onUpdate: (tradingEntity: Partial<TradingEntity>) => void
}

export const ProductsPanel: React.FC<ProductsPanelProps> = ({ tradingEntity, readOnly, onUpdate }) => {
  return (
    <ProductRightsPanel
      hideViewPermission={true}
      hideWritePermission={true}
      onUpdate={productRights => onUpdate({ productRights })}
      productRights={tradingEntity.productRights}
      readOnly={readOnly}
    />
  )
}
